<div class="create-account-ui">

  <se-fe-card se-data-full-width-header="true" se-data-spacious="true">
    <se-fe-card-content >
      <header class="page-header">
        <img
          alt="SportsEngine"
          [src]="logo">
      </header>

      <div class="page-content">
        <router-outlet></router-outlet>
      </div>

      <footer class="page-footer">
        <p><a href="https://www.sportsengine.com/solutions" seFeLink>What's SportsEngine?</a></p>
        <p>Need Help? <a href="https://intercom.help/SportsEngine/en/" seFeLink>SportsEngine Help Center</a></p>
      </footer>
    </se-fe-card-content>
  </se-fe-card>

  <footer class="se-footer">
    <a seFeLink
        target="_blank"
        href="https://www.sportsengine.com/terms-of-use"
        (click)="trackEvent('TermsOfServiceClick')">Terms of Use</a> |
    <a seFeLink
        target="_blank"
        href="https://www.nbcuniversal.com/privacy?brandA=SportsEngine&intake=SportsEngine"
        (click)="trackEvent('PrivacyPolicyClick')">Privacy Policy - New</a>
    <br>
    © 2020 - {{ footerYear }}
    <a seFeLink
        target="_blank"
        href="http://www.sportsengine.com"
        (click)="trackEvent('SportsEngineHomepageClick')">SportsEngine.</a>
    All Rights Reserved.
  </footer>
</div>
